'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('./utils.js');

var utils = _interopRequireWildcard(_utils);

var _intlMessageformat = require('intl-messageformat');

var _intlMessageformat2 = _interopRequireDefault(_intlMessageformat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getDefaults() {
  return {
    memoize: true,
    memoizeFallback: false
  };
}

var ICU = function () {
  function ICU(options) {
    _classCallCheck(this, ICU);

    this.type = 'i18nFormat';
    this.mem = {};

    this.init(null, options);
  }

  _createClass(ICU, [{
    key: 'init',
    value: function init(i18next, options) {
      var i18nextOptions = i18next && i18next.options && i18next.options.i18nFormat || {};
      this.options = utils.defaults(i18nextOptions, options, this.options || {}, getDefaults());
      this.formats = this.options.formats;

      if (i18next) {
        i18next.IntlMessageFormat = _intlMessageformat2.default;
        i18next.ICU = this;
      }

      if (this.options.localeData) this.addLocaleData(this.options.localeData);
    }
  }, {
    key: 'addLocaleData',
    value: function addLocaleData(data) {
      var locales = Object.prototype.toString.apply(data) === '[object Array]' ? data : [data];

      locales.forEach(function (localeData) {
        if (localeData && localeData.locale) {
          _intlMessageformat2.default.__addLocaleData(localeData);
          // IntlRelativeFormat.__addLocaleData(localeData);
        }
      });
    }
  }, {
    key: 'addUserDefinedFormats',
    value: function addUserDefinedFormats(formats) {
      this.formats = this.formats ? _extends({}, this.formats, formats) : formats;
    }
  }, {
    key: 'parse',
    value: function parse(res, options, lng, ns, key, info) {
      var hadSuccessfulLookup = info && info.resolved && info.resolved.res;

      var fc = void 0;
      if (this.options.memoize) {
        fc = utils.getPath(this.mem, lng + '.' + ns + '.' + key);
      }
      if (!fc) {
        fc = new _intlMessageformat2.default(res, lng, this.formats);
        if (this.options.memoize && (this.options.memoizeFallback || !info || hadSuccessfulLookup)) utils.setPath(this.mem, lng + '.' + ns + '.' + key, fc);
      }
      return fc.format(options);
    }
  }, {
    key: 'addLookupKeys',
    value: function addLookupKeys(finalKeys, key, code, ns, options) {
      // no additional keys needed for select or plural
      // so there is no need to add keys to that finalKeys array
      return finalKeys;
    }
  }]);

  return ICU;
}();

ICU.type = 'i18nFormat';

exports.default = ICU;